import React, { useState } from 'react'
import versionInfo from '../version.json'

const BuildVersionWatermark: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  const formatBuildTime = (isoString: string) => {
    try {
      const date = new Date(isoString)
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    } catch {
      return isoString
    }
  }

  return (
    <div
      className="fixed bottom-2 left-2 z-[9999] select-none cursor-pointer"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      {isExpanded ? (
        <div className="bg-black/80 text-white text-xs rounded-lg p-3 shadow-lg backdrop-blur-sm border border-white/10">
          <div className="font-semibold mb-2 text-emerald-400">Build Info</div>
          <div className="space-y-1">
            <div className="flex gap-2">
              <span className="text-gray-400">Version:</span>
              <span className="font-mono">{versionInfo.version}</span>
            </div>
            <div className="flex gap-2">
              <span className="text-gray-400">Commit:</span>
              <span className="font-mono text-blue-400">{versionInfo.commit}</span>
            </div>
            <div className="flex gap-2">
              <span className="text-gray-400">Built:</span>
              <span className="font-mono">{formatBuildTime(versionInfo.buildTime)}</span>
            </div>
          </div>
          <div className="text-[10px] text-gray-500 mt-2 text-center">Click to collapse</div>
        </div>
      ) : (
        <div className="bg-black/60 text-white text-[10px] rounded px-2 py-1 shadow backdrop-blur-sm border border-white/10 hover:bg-black/80 transition-colors">
          <span className="font-mono">v{versionInfo.version}</span>
          <span className="text-gray-400 ml-1">({versionInfo.commit})</span>
        </div>
      )}
    </div>
  )
}

export default BuildVersionWatermark
